import { render, staticRenderFns } from "./selectCustomers.vue?vue&type=template&id=6d2f2cd0&"
import script from "./selectCustomers.vue?vue&type=script&lang=js&"
export * from "./selectCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports